export default "__VITE_ASSET__C$ivQ5Og__"